/* FamPrints header search: suggestions + products from Shopify's Predictive Search API.
   Works next to global.js (which only handles the trending/recent panel). */
(function () {
  'use strict';

  var DEBOUNCE_MS = 250;
  var MIN_CHARS = 1;

  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  function rememberSearch(term) {
    if (!term) return;
    try {
      var list = JSON.parse(localStorage.getItem('search-recent') || '[]');
      if (!Array.isArray(list)) list = [];
      list = list.filter(function (item) { return item !== term; });
      list.unshift(term);
      localStorage.setItem('search-recent', JSON.stringify(list.slice(0, 3)));
    } catch (e) { /* storage unavailable */ }
  }

  function FamprintsSearch(wrapper) {
    this.wrapper = wrapper;
    this.input = wrapper.querySelector('.famprints-header__search-input');
    this.results = wrapper.querySelector('.famprints-search-results');
    this.form = wrapper.querySelector('form');
    if (!this.input || !this.results) return;

    this.suggestUrl = this.results.dataset.suggestUrl || '/search/suggest';
    this.searchUrl = this.results.dataset.searchUrl || '/search';
    this.sectionId = this.results.dataset.sectionId || 'predictive-search';
    this.limit = parseInt(this.results.dataset.limit || '4', 10);
    this.cache = {};
    this.controller = null;
    this.currentTerm = '';

    this.onInput = debounce(this.search.bind(this), DEBOUNCE_MS);
    this.input.addEventListener('input', this.onInput);
    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.input.addEventListener('keydown', this.onKeydown.bind(this));
    this.results.addEventListener('click', this.onResultClick.bind(this));
    if (this.form) {
      this.form.addEventListener('submit', function () { rememberSearch(this.input.value.trim()); }.bind(this));
    }
    var cancel = wrapper.closest('.famprints-header__search') && wrapper.closest('.famprints-header__search').querySelector('.famprints-header__cancel-btn');
    if (cancel) cancel.addEventListener('click', this.close.bind(this));

    document.addEventListener('click', function (event) {
      if (!this.wrapper.contains(event.target)) this.close();
    }.bind(this));
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') this.close();
    }.bind(this));
  }

  FamprintsSearch.prototype.onFocus = function () {
    var term = this.input.value.trim();
    if (term.length >= MIN_CHARS && this.cache[term]) this.render(this.cache[term], term);
  };

  FamprintsSearch.prototype.search = function () {
    var term = this.input.value.trim();
    this.currentTerm = term;
    if (term.length < MIN_CHARS) { this.close(); return; }
    if (this.cache[term]) { this.render(this.cache[term], term); return; }

    if (this.controller) this.controller.abort();
    this.controller = new AbortController();
    var signal = this.controller.signal;
    this.results.classList.add('is-loading');

    var params = new URLSearchParams();
    params.set('q', term);
    params.set('resources[type]', 'product,query');
    params.set('resources[limit]', String(this.limit));
    params.set('resources[limit_scope]', 'each');
    params.set('resources[options][unavailable_products]', 'hide');
    params.set('resources[options][fields]', 'title,product_type,variants.title,vendor,tag');
    params.set('section_id', this.sectionId);

    var countParams = new URLSearchParams();
    countParams.set('q', term);
    countParams.set('type', 'product');
    countParams.set('view', 'count');

    var self = this;
    var htmlRequest = fetch(this.suggestUrl + '?' + params.toString(), { signal: signal })
      .then(function (res) { return res.ok ? res.text() : Promise.reject(res.status); });
    var countRequest = fetch(this.searchUrl + '?' + countParams.toString(), { signal: signal })
      .then(function (res) { return res.ok ? res.text() : ''; })
      .catch(function () { return ''; });

    Promise.all([htmlRequest, countRequest]).then(function (values) {
      var doc = new DOMParser().parseFromString(values[0], 'text/html');
      var section = doc.querySelector('#shopify-section-' + self.sectionId) || doc.body;
      var count = parseInt(String(values[1]).trim(), 10);
      var payload = { html: section.innerHTML, count: isNaN(count) ? null : count };
      self.cache[term] = payload;
      if (self.currentTerm === term) self.render(payload, term);
    }).catch(function (error) {
      if (error && error.name === 'AbortError') return;
      self.results.classList.remove('is-loading');
    });
  };

  FamprintsSearch.prototype.render = function (payload, term) {
    this.results.innerHTML = payload.html;
    this.results.classList.remove('is-loading');

    var viewAll = this.results.querySelector('[data-view-all]');
    if (viewAll) {
      var textEl = viewAll.querySelector('.famprints-search-view-all__text') || viewAll;
      var label = textEl.textContent;
      if (payload.count !== null && payload.count > 0) {
        label = label.replace('{count}', payload.count.toLocaleString());
      } else {
        label = label.replace(/\{count\}\s*/, '');
      }
      textEl.textContent = label;
      if (payload.count === 0) viewAll.closest('.famprints-search-results__footer').hidden = true;
    }

    var inner = this.results.querySelector('.famprints-search-results__inner');
    if (!inner || inner.dataset.hasResults !== 'true') {
      if (inner) this.open(); else this.close();
      return;
    }
    this.open();
  };

  FamprintsSearch.prototype.open = function () {
    this.results.classList.add('is-open');
    this.input.setAttribute('aria-expanded', 'true');
    var trending = this.wrapper.querySelector('.app_results_container');
    if (trending) trending.style.display = 'none';
  };

  FamprintsSearch.prototype.close = function () {
    this.results.classList.remove('is-open');
    this.input.setAttribute('aria-expanded', 'false');
  };

  FamprintsSearch.prototype.onResultClick = function (event) {
    var link = event.target.closest('a[data-suggestion]');
    if (!link) return;
    rememberSearch(link.dataset.suggestion);
  };

  FamprintsSearch.prototype.onKeydown = function (event) {
    if (!this.results.classList.contains('is-open')) return;
    var links = Array.prototype.slice.call(this.results.querySelectorAll('.famprints-search-suggestion, .famprints-search-product, .famprints-search-view-all'));
    if (!links.length) return;
    var index = links.findIndex(function (el) { return el.classList.contains('is-active'); });

    if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
      event.preventDefault();
      if (index > -1) links[index].classList.remove('is-active');
      index = event.key === 'ArrowDown' ? (index + 1) % links.length : (index <= 0 ? links.length - 1 : index - 1);
      links[index].classList.add('is-active');
      links[index].scrollIntoView({ block: 'nearest' });
    } else if (event.key === 'Enter' && index > -1) {
      event.preventDefault();
      rememberSearch(links[index].dataset.suggestion || this.input.value.trim());
      window.location.href = links[index].href;
    }
  };

  function init() {
    document.querySelectorAll('.famprints-header__search-form').forEach(function (wrapper) {
      if (wrapper.famprintsSearch) return;
      wrapper.famprintsSearch = new FamprintsSearch(wrapper);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
